import { isIframe } from 'utils/helper-functions/is-iframe';

export const HEADER_BUTTON_LAYOUTS = ['panoramic', 'amount-first'];

export interface HeaderButtonsInput {
  showBackButton?: boolean | null;
  showCloseButton?: boolean | null;
  layout?: string | null;
  headerStyle?: string | null;
  isInIframe?: boolean;
}

export interface HeaderButtonsSettings {
  showBackButton: boolean;
  showCloseButton: boolean;
  showAnyHeaderButton: boolean;
}

export const supportsTabsHeader = ({
  layout,
  headerStyle,
}: Pick<HeaderButtonsInput, 'layout' | 'headerStyle'>): boolean => {
  const supportedLayout = layout == null || HEADER_BUTTON_LAYOUTS.includes(layout);
  return supportedLayout && (layout === 'amount-first' || headerStyle === 'modern');
};

export const resolveHeaderButtons = ({
  showBackButton,
  showCloseButton,
  layout,
  headerStyle,
  isInIframe = isIframe(),
}: HeaderButtonsInput): HeaderButtonsSettings => {
  const enabled = isInIframe && supportsTabsHeader({ layout, headerStyle });

  const back = enabled && showBackButton === true;
  const close = enabled && showCloseButton === true;

  return {
    showBackButton: back,
    showCloseButton: close,
    showAnyHeaderButton: back || close,
  };
};
